export default function CTASection() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20fashion%20display%20window%20at%20dusk%20with%20mannequins%20in%20designer%20outfits%20illuminated%20by%20warm%20golden%20spotlights%20on%20rain%20slicked%20cobblestone%20street%2C%20reflection%20of%20city%20lights%20on%20wet%20pavement%2C%20luxury%20retail%20atmosphere%2C%20cinematic%20photography%20with%20moody%20amber%20and%20charcoal%20tones&width=1800&height=1000&seq=cta-bg-v2&orientation=landscape"
          alt="Acquista su Kaspreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/50"></div>
      </div>

      <div className="relative z-10 text-center px-4 w-full max-w-3xl mx-auto">
        <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight tracking-wide uppercase mb-4">
          Acquista Ora Su Kaspreadsheet
        </h2>
        <p className="text-sm md:text-base text-background-50/80 max-w-xl mx-auto leading-relaxed mb-8">
          Visita il sito principale per esplorare tutti i prodotti disponibili. Trova esattamente ciò che cerchi con Itaobuy Spreadsheet.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold whitespace-nowrap transition-all hover:bg-foreground-800 cursor-pointer group"
        >
          <span className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-500">
            <i className="ri-shopping-bag-line text-background-50 text-xs"></i>
          </span>
          <span className="uppercase tracking-wide">Buy It Now</span>
          <i className="ri-arrow-right-up-line text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}